(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-articles-grouped"] && !Shopify.designMode) return;
  try {
    
  class BlogArticlesGroupedFilter {
    constructor(section) {
      this.section = section;
      this.filterButtons = section.querySelectorAll('.blog-articles-grouped__filter-pill');
      this.articles = section.querySelectorAll('.blog-articles-grouped__article');
      this.currentFilter = 'all';

      this.init();
    }

    init() {
      this.filterButtons.forEach((button) => {
        button.addEventListener('click', (e) => this.handleFilterClick(e));
      });
    }

    handleFilterClick(e) {
      const button = e.currentTarget;
      const category = button.dataset.category;
      const filterType = button.dataset.filterType || 'all';

      this.currentFilter = category;

      this.filterButtons.forEach((btn) => {
        btn.classList.remove('blog-articles-grouped__filter-pill--active');
        btn.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('blog-articles-grouped__filter-pill--active');
      button.setAttribute('aria-pressed', 'true');

      this.filterArticles(category, filterType);

      // Trigger pagination reset if pagination is enabled
      const paginationManager = this.section.paginationManager;
      if (paginationManager) {
        paginationManager.resetPagination();
      }
    }

    filterArticles(category, filterType) {
      this.articles.forEach((article) => {
        const articleCategory = article.dataset.category;
        const articleTags = article.dataset.tags ? article.dataset.tags.split(',') : [];

        let shouldShow = false;

        if (category === 'all') {
          shouldShow = true;
        } else {
          // Show article if EITHER the metafield category matches OR any tag matches
          // This allows merged filtering where both categories and tags work together
          if (articleCategory === category) {
            shouldShow = true;
          } else if (articleTags.includes(category)) {
            shouldShow = true;
          }
        }

        if (shouldShow) {
          article.classList.remove('blog-articles-grouped__article--hidden');
        } else {
          article.classList.add('blog-articles-grouped__article--hidden');
        }
      });
    }

    getCurrentFilter() {
      return this.currentFilter;
    }
  }

  class BlogArticlesPagination {
    constructor(section, initialArticlesToShow) {
      this.section = section;
      this.articles = Array.from(section.querySelectorAll('.blog-articles-grouped__article'));
      this.initialArticlesToShow = initialArticlesToShow || 6;
      this.articlesPerLoad = initialArticlesToShow || 6;
      this.currentIndex = 0;
      this.loadMoreWrapper = section.querySelector('.blog-articles-grouped__load-more-wrapper');
      this.loadMoreBtn = section.querySelector('.blog-articles-grouped__load-more-btn');

      this.init();
    }

    init() {
      if (!this.loadMoreBtn) return;

      // Initially hide all articles
      this.articles.forEach((article) => {
        article.style.display = 'none';
      });

      // Show initial articles
      this.showNextBatch();

      // Add load more event listener
      this.loadMoreBtn.addEventListener('click', () => this.showNextBatch());
    }

    showNextBatch() {
      const filterManager = this.section.filterManager;
      const visibleArticles = this.articles.filter((article) => {
        return !article.classList.contains('blog-articles-grouped__article--hidden');
      });

      let shown = 0;
      for (let i = this.currentIndex; i < visibleArticles.length && shown < this.articlesPerLoad; i++) {
        visibleArticles[i].style.display = '';
        this.currentIndex = i + 1;
        shown++;
      }

      // Update load more button visibility
      if (this.currentIndex >= visibleArticles.length) {
        this.loadMoreWrapper.style.display = 'none';
      } else {
        this.loadMoreWrapper.style.display = 'block';
      }
    }

    resetPagination() {
      this.currentIndex = 0;

      // Hide all articles
      this.articles.forEach((article) => {
        article.style.display = 'none';
      });

      // Show the first batch
      this.showNextBatch();
    }

    updateVisibility() {
      // Called when filter changes
      const visibleArticles = this.articles.filter((article) => {
        return !article.classList.contains('blog-articles-grouped__article--hidden');
      });

      // Count how many are already displayed
      let displayedCount = 0;
      visibleArticles.forEach((article) => {
        if (article.style.display !== 'none') {
          displayedCount++;
        }
      });

      this.currentIndex = displayedCount;

      // Update button visibility
      if (this.currentIndex >= visibleArticles.length) {
        this.loadMoreWrapper.style.display = 'none';
      } else {
        this.loadMoreWrapper.style.display = 'block';
      }
    }
  }

  class BlogArticlesRandomizer {
    constructor(grid) {
      this.grid = grid;
      this.articles = Array.from(grid.querySelectorAll('.blog-articles-grouped__article'));
      this.limit = parseInt(grid.dataset.articlesLimit) || 0;

      this.randomize();
    }

    randomize() {
      if (this.articles.length === 0) return;

      // Fisher-Yates shuffle algorithm
      const shuffled = [...this.articles];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      // Hide all articles first
      this.articles.forEach((article) => {
        article.style.display = 'none';
      });

      // Show only the limited number of shuffled articles
      const articlesToShow = this.limit > 0 ? shuffled.slice(0, this.limit) : shuffled;

      articlesToShow.forEach((article, index) => {
        article.style.display = '';
        article.style.order = index;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.blog-articles-grouped[data-section-id]');
    sections.forEach((section) => {
      // Initialize filter
      if (section.querySelector('.blog-articles-grouped__filter')) {
        const filterManager = new BlogArticlesGroupedFilter(section);
        section.filterManager = filterManager;
      }

      // Initialize pagination
      const loadMoreWrapper = section.querySelector('.blog-articles-grouped__load-more-wrapper');
      if (loadMoreWrapper) {
        const initialArticlesToShow = parseInt(section.dataset.initialArticles) || 6;
        const paginationManager = new BlogArticlesPagination(section, initialArticlesToShow);
        section.paginationManager = paginationManager;
      }

      // Initialize randomizer (only if pagination is not enabled)
      if (!loadMoreWrapper) {
        const gridsToRandomize = section.querySelectorAll('.blog-articles-grouped__grid[data-randomize="true"]');
        gridsToRandomize.forEach((grid) => {
          new BlogArticlesRandomizer(grid);
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["destini-locator"] && !Shopify.designMode) return;
  try {
    
  // Attempt to modify iframe content (only works if same-origin)
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      try {
        const iframe = document.querySelector('iframe#destini');
        if (iframe && iframe.contentDocument) {
          const style = iframe.contentDocument.createElement('style');
          style.textContent = `
            .destini-css-2s70hr {
              background-color: #9DE7D7 !important;
            }
          `;
          iframe.contentDocument.head.appendChild(style);
        }
      } catch (e) {
        // Cross-origin restriction - cannot modify iframe
        console.log('Cannot modify iframe styles due to cross-origin restrictions');
      }
    }, 2000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-grouped"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const pillLinks = document.querySelectorAll('.faq-grouped__pill');

    pillLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flip-card-carousel"] && !Shopify.designMode) return;
  try {
    
  class FlipCardCarousel extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('.flip-card');
      this.cardsInner = this.querySelector('.flip-card-carousel__cards-inner');
      this.prevBtn = this.querySelector('.flip-card-carousel__nav-btn--prev');
      this.nextBtn = this.querySelector('.flip-card-carousel__nav-btn--next');
      this.nav = this.querySelector('.flip-card-carousel__nav');
      this.hoverFlipEnabled = this.dataset.hoverFlip === 'true';

      this.init();
    }

    init() {
      // Setup flip functionality
      this.cards.forEach((card) => {
        const flipBtns = card.querySelectorAll('.flip-card__flip-btn');

        // Click/tap functionality - always enabled
        flipBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            card.classList.toggle('is-flipped');
          });
        });

        // Only add hover listeners if hover mode is disabled
        // This prevents conflicts between hover and click
        if (!this.hoverFlipEnabled) {
          // Touch support for mobile (tap anywhere on card)
          let touchStartX = 0;
          let touchEndX = 0;

          card.addEventListener(
            'touchstart',
            (e) => {
              touchStartX = e.changedTouches[0].screenX;
            },
            { passive: true }
          );

          card.addEventListener(
            'touchend',
            (e) => {
              touchEndX = e.changedTouches[0].screenX;
              // Only flip if it's a tap (not a swipe)
              if (Math.abs(touchEndX - touchStartX) < 10) {
                card.classList.toggle('is-flipped');
              }
            },
            { passive: true }
          );
        }
      });

      // Setup carousel navigation
      if (this.prevBtn && this.nextBtn && this.cardsInner) {
        this.prevBtn.addEventListener('click', () => this.scrollCarousel('prev'));
        this.nextBtn.addEventListener('click', () => this.scrollCarousel('next'));

        // Check if navigation should be visible
        this.checkNavVisibility();

        // Re-check on window resize
        window.addEventListener('resize', () => this.checkNavVisibility());
      }
    }

    checkNavVisibility() {
      if (!this.cardsInner || !this.nav) return;

      // Check if content is scrollable (scrollWidth > clientWidth)
      const isScrollable = this.cardsInner.scrollWidth > this.cardsInner.clientWidth;

      if (isScrollable) {
        this.nav.style.display = 'flex';
      } else {
        this.nav.style.display = 'none';
      }
    }

    scrollCarousel(direction) {
      const scrollAmount = this.cardsInner.offsetWidth * 0.8;
      const currentScroll = this.cardsInner.scrollLeft;

      if (direction === 'prev') {
        this.cardsInner.scrollTo({
          left: currentScroll - scrollAmount,
          behavior: 'smooth',
        });
      } else {
        this.cardsInner.scrollTo({
          left: currentScroll + scrollAmount,
          behavior: 'smooth',
        });
      }
    }
  }

  customElements.define('flip-card-carousel', FlipCardCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-media-text-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Minimum px travel before a swipe/drag is recognised as intentional
    var SWIPE_THRESHOLD = 40;

    /**
     * Carousel controller for a single smtc-carousel element.
     * Handles slide transitions, dot navigation, and touch/mouse drag.
     */
    function SmtcCarousel(el) {
      this.el = el;
      this.slides = Array.from(el.querySelectorAll('.smtc-carousel__slide'));
      this.dots = Array.from(el.querySelectorAll('.smtc-carousel__dot'));
      this.current = 0;

      var self = this;
      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          self.goTo(i);
        });
      });

      this._bindDrag();
    }

    SmtcCarousel.prototype.goTo = function (index) {
      if (index === this.current) return;
      var prev = this.current;
      this.current = index;

      this.slides[prev].classList.remove('smtc-carousel__slide--active');
      this.slides[prev].setAttribute('aria-hidden', 'true');
      this.slides[index].classList.add('smtc-carousel__slide--active');
      this.slides[index].setAttribute('aria-hidden', 'false');

      if (this.dots[prev]) {
        this.dots[prev].classList.remove('smtc-carousel__dot--active');
        this.dots[prev].setAttribute('aria-selected', 'false');
      }
      if (this.dots[index]) {
        this.dots[index].classList.add('smtc-carousel__dot--active');
        this.dots[index].setAttribute('aria-selected', 'true');
      }
    };

    SmtcCarousel.prototype.next = function () {
      this.goTo((this.current + 1) % this.slides.length);
    };

    SmtcCarousel.prototype.prev = function () {
      this.goTo((this.current - 1 + this.slides.length) % this.slides.length);
    };

    /**
     * Attach touch and mouse drag listeners once at construction time.
     * Uses instance properties for startX/isDragging so there is only
     * ever one set of listeners regardless of how many times setImages runs.
     */
    SmtcCarousel.prototype._bindDrag = function () {
      var self = this;
      var track = this.el.querySelector('.smtc-carousel__track');
      if (!track) return;

      // State lives on the instance so all closures share the same values
      self._dragStartX = 0;
      self._dragging = false;

      // ── Touch ──────────────────────────────────────────────────────────
      track.addEventListener(
        'touchstart',
        function (e) {
          if (self.slides.length < 2) return;
          self._dragStartX = e.touches[0].clientX;
          self._dragging = true;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchend',
        function (e) {
          if (!self._dragging) return;
          self._dragging = false;
          var delta = e.changedTouches[0].clientX - self._dragStartX;
          if (Math.abs(delta) < SWIPE_THRESHOLD) return;
          if (delta < 0) {
            self.next();
          } else {
            self.prev();
          }
        },
        { passive: true }
      );

      track.addEventListener(
        'touchcancel',
        function () {
          self._dragging = false;
        },
        { passive: true }
      );

      // ── Mouse drag ─────────────────────────────────────────────────────
      track.addEventListener('mousedown', function (e) {
        if (self.slides.length < 2) return;
        self._dragStartX = e.clientX;
        self._dragging = true;
        track.style.cursor = 'grabbing';
        e.preventDefault();
      });

      window.addEventListener('mouseup', function (e) {
        if (!self._dragging) return;
        self._dragging = false;
        track.style.cursor = '';
        var delta = e.clientX - self._dragStartX;
        if (Math.abs(delta) < SWIPE_THRESHOLD) return;
        if (delta < 0) {
          self.next();
        } else {
          self.prev();
        }
      });

      window.addEventListener('mouseleave', function () {
        if (self._dragging) {
          self._dragging = false;
          track.style.cursor = '';
        }
      });
    };

    /**
     * Replace all slides with a new array of image URLs.
     * Rebuilds slides and dots, re-binds drag, then shows the first slide.
     */
    SmtcCarousel.prototype.setImages = function (urls, altText) {
      var track = this.el.querySelector('.smtc-carousel__track');
      var dotsContainer = this.el.querySelector('.smtc-carousel__dots');

      track.innerHTML = '';
      urls.forEach(function (url, i) {
        var slide = document.createElement('div');
        slide.className = 'smtc-carousel__slide' + (i === 0 ? ' smtc-carousel__slide--active' : '');
        slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');

        var img = document.createElement('img');
        img.src = url;
        img.srcset = buildSrcset(url);
        img.sizes = '(min-width: 990px) 50vw, 100vw';
        img.className = 'split-media-text-card__image';
        img.loading = i === 0 ? 'eager' : 'lazy';
        img.alt = altText || '';

        slide.appendChild(img);
        track.appendChild(slide);
      });

      this.slides = Array.from(track.querySelectorAll('.smtc-carousel__slide'));
      this.current = 0;

      // Toggle multi-image class on the wrapper for cursor/style purposes
      this.el.classList.toggle('smtc-carousel--multi', urls.length > 1);

      if (dotsContainer) {
        if (urls.length > 1) {
          dotsContainer.innerHTML = '';
          var self = this;
          urls.forEach(function (_, i) {
            var dot = document.createElement('button');
            dot.className = 'smtc-carousel__dot' + (i === 0 ? ' smtc-carousel__dot--active' : '');
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
            dot.setAttribute('data-index', i);
            dot.addEventListener('click', function () {
              self.goTo(i);
            });
            dotsContainer.appendChild(dot);
          });
          dotsContainer.style.display = '';
        } else {
          dotsContainer.innerHTML = '';
          dotsContainer.style.display = 'none';
        }
        this.dots = Array.from(dotsContainer.querySelectorAll('.smtc-carousel__dot'));
      }

      // Re-bind drag on the new track content
      this._bindDrag();
    };

    function buildSrcset(baseUrl) {
      return [400, 600, 800, 1000, 1200, 1500]
        .map(function (w) {
          if (baseUrl.indexOf('width=') !== -1) {
            return baseUrl.replace(/(width=)\d+/, '$1' + w) + ' ' + w + 'w';
          }
          var sep = baseUrl.indexOf('?') !== -1 ? '&' : '?';
          return baseUrl + sep + 'width=' + w + ' ' + w + 'w';
        })
        .join(', ');
    }

    function initCarousel(el) {
      var sectionId = el.getAttribute('data-smtc-carousel');
      if (!sectionId) return;

      var carousel = new SmtcCarousel(el);

      var variantImagesMap = {};
      var fallbackImages = [];

      try {
        variantImagesMap = JSON.parse(el.getAttribute('data-variant-images') || '{}');
      } catch (e) {}
      try {
        fallbackImages = JSON.parse(el.getAttribute('data-fallback-images') || '[]');
      } catch (e) {}

      function getImagesForVariant(variant) {
        if (!variant) return fallbackImages;
        var imgs = variantImagesMap[String(variant.id)];
        return imgs && imgs.length > 0 ? imgs : fallbackImages;
      }

      function handleVariantChange(variant) {
        var imgs = getImagesForVariant(variant);
        if (imgs && imgs.length > 0) carousel.setImages(imgs, variant ? variant.title : '');
      }

      // Dawn pub/sub
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event && event.data && event.data.variant) handleVariantChange(event.data.variant);
        });
      }

      // Legacy custom event
      document.addEventListener('variant:change', function (e) {
        if (e.detail && e.detail.variant) handleVariantChange(e.detail.variant);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-smtc-carousel]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  // ── Section background image variant swap ──────────────────────────────────
  (function () {
    function initSectionBgSwap(bgEl) {
      var variantMap = {};
      try {
        variantMap = JSON.parse(bgEl.getAttribute('data-section-bg-variants') || '{}');
      } catch (e) {
        console.warn('[smtc bg] Failed to parse variant map:', e);
      }

      if (!Object.keys(variantMap).length) return;

      var fallbackUrl = bgEl.getAttribute('data-section-bg-fallback') || '';
      var img = bgEl.querySelector('.split-media-text-card__section-bg-img');
      if (!img) return;

      function setUrl(url) {
        if (!url) return;
        img.src = url;
        img.srcset = [800, 1200, 1600, 2000]
          .map(function (w) {
            // Shopify CDN URLs already have query params — append width
            var sep = url.indexOf('?') !== -1 ? '&' : '?';
            return url + sep + 'width=' + w + ' ' + w + 'w';
          })
          .join(', ');
      }

      function swap(variant) {
        if (!variant) return;
        var url = variantMap[String(variant.id)] || fallbackUrl;
        setUrl(url);
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          if (event && event.data && event.data.variant) swap(event.data.variant);
        });
      }

      document.addEventListener('variant:change', function (e) {
        if (e.detail && e.detail.variant) swap(e.detail.variant);
      });
    }

    function initAllBgSwaps() {
      document.querySelectorAll('[data-section-bg-variants]').forEach(initSectionBgSwap);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllBgSwaps);
    } else {
      initAllBgSwaps();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    // Handle centered video play button overlay
    document.querySelectorAll('[data-video-play-overlay]').forEach(function (btn) {
      var mediaContainer = btn.closest('.story-hero__media--video');
      if (!mediaContainer) return;

      var video = mediaContainer.querySelector('.story-hero__video-el');
      if (!video) return;

      var section = btn.closest('.story-hero');
      var modal = section ? section.querySelector('.story-hero__video-modal') : null;

      // Play video when overlay button is clicked
      btn.addEventListener('click', function () {
        if (isMobile && modal) {
          // On mobile, open modal with video
          openVideoModal(modal, video);
        } else {
          // On desktop, play inline
          video.play();
          btn.classList.add('is-hidden');
        }
      });

      // Show overlay when video is paused (desktop only)
      if (!isMobile) {
        video.addEventListener('pause', function () {
          btn.classList.remove('is-hidden');
        });

        // Hide overlay when video is playing
        video.addEventListener('play', function () {
          btn.classList.add('is-hidden');
        });

        // Show overlay when video ends
        video.addEventListener('ended', function () {
          btn.classList.remove('is-hidden');
        });
      }
    });

    // Function to open video modal on mobile
    function openVideoModal(modal, video) {
      var modalVideo = modal.querySelector('.story-hero__video-modal-player');
      if (!modalVideo) return;

      // Clone video source to modal
      modalVideo.src = video.src || video.querySelector('source').src;

      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      // Play video in modal
      modalVideo.play();

      function closeVideoModal() {
        modal.hidden = true;
        modalVideo.pause();
        modalVideo.currentTime = 0;
        document.body.style.overflow = '';
      }

      var closeBtn = modal.querySelector('.story-hero__video-modal-close');
      var backdrop = modal.querySelector('.story-hero__video-modal-backdrop');

      if (closeBtn) closeBtn.addEventListener('click', closeVideoModal, { once: true });
      if (backdrop) backdrop.addEventListener('click', closeVideoModal, { once: true });

      document.addEventListener('keydown', function onKey(e) {
        if (e.key === 'Escape') {
          closeVideoModal();
          document.removeEventListener('keydown', onKey);
        }
      });
    }

    // Handle external video modal (YouTube/Vimeo)
    document.querySelectorAll('.story-hero__play-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.story-hero');
        if (!section) return;
        var modal = section.querySelector('.story-hero__modal');
        var embed = section.querySelector('.story-hero__modal-embed');
        if (!modal || !embed) return;

        var url = btn.dataset.videoUrl;
        var isYoutube = btn.dataset.isYoutube === 'true';
        var isVimeo = btn.dataset.isVimeo === 'true';
        var embedUrl = '';

        if (isYoutube) {
          var ytId = url.match(/(?:v=|youtu\.be\/)([^&?/]+)/);
          if (ytId) embedUrl = 'https://www.youtube.com/embed/' + ytId[1] + '?autoplay=1&rel=0';
        } else if (isVimeo) {
          var vmId = url.match(/vimeo\.com\/(\d+)/);
          if (vmId) embedUrl = 'https://player.vimeo.com/video/' + vmId[1] + '?autoplay=1';
        }

        if (!embedUrl) return;

        embed.innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; fullscreen" allowfullscreen></iframe>';
        modal.hidden = false;
        document.body.style.overflow = 'hidden';

        function closeModal() {
          modal.hidden = true;
          embed.innerHTML = '';
          document.body.style.overflow = '';
        }

        modal.querySelector('.story-hero__modal-close').addEventListener('click', closeModal, { once: true });
        modal.querySelector('.story-hero__modal-backdrop').addEventListener('click', closeModal, { once: true });
        document.addEventListener('keydown', function onKey(e) {
          if (e.key === 'Escape') {
            closeModal();
            document.removeEventListener('keydown', onKey);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
